import { createContext } from 'react';

export const RevUserContext = createContext(null);